import { render, staticRenderFns } from "./FAQs.vue?vue&type=template&id=b99c5f60"
import script from "./FAQs.vue?vue&type=script&lang=js"
export * from "./FAQs.vue?vue&type=script&lang=js"
import style0 from "./FAQs.vue?vue&type=style&index=0&id=b99c5f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports